import axios from "axios";
import { buildApiUrl } from "../config/api";

function downloadBlob(filename, blob) {
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(url);
}

export async function downloadEmisReport({ schoolId, report, academicYear, term, from, to }) {
    const params = { report, format: "csv" };
    if (academicYear) params.academicYear = academicYear;
    if (term) params.term = term;
    if (from) params.from = from;
    if (to) params.to = to;

    try {
        const response = await axios.get(buildApiUrl(`/EmisReports/${schoolId}/export`), {
            params,
            responseType: "blob",
        });

        const disposition = response.headers["content-disposition"] || "";
        const match = /filename="([^"]+)"/i.exec(disposition);
        const filename = match?.[1] || `EMIS-${report}.csv`;
        downloadBlob(filename, response.data);
    } catch (err) {
        const blob = err.response?.data;
        if (blob instanceof Blob) {
            const text = await blob.text();
            try {
                const body = JSON.parse(text);
                throw new Error(body.message || "Export failed");
            } catch (parseErr) {
                if (parseErr instanceof Error && parseErr.message !== "Export failed") throw parseErr;
            }
        }
        throw new Error(err.response?.data?.message || err.message || "Export failed");
    }
}

export async function fetchEmisDashboard({ schoolId, academicYear, term, from, to }) {
    const params = {};
    if (academicYear) params.academicYear = academicYear;
    if (term) params.term = term;
    if (from) params.from = from;
    if (to) params.to = to;

    const { data } = await axios.get(buildApiUrl(`/EmisReports/${schoolId}`), { params });
    return data;
}
